import { api } from "./api";

export type SubscriptionPlan = "free" | "pro" | "enterprise";
export type WorkspaceRole = "owner" | "admin" | "member";

export interface Workspace {
  id: string;
  slug: string;
  name: string;
  ownerUserId: string;
  subscriptionPlan: SubscriptionPlan;
  role: WorkspaceRole;
  createdAt: string;
  updatedAt: string;
}

export interface CreateWorkspaceInput {
  name: string;
  slug?: string;
}

export interface UpdateWorkspaceInput {
  name?: string;
  subscriptionPlan?: SubscriptionPlan;
}

export interface Member {
  userId: string;
  email: string | null;
  name: string | null;
  role: WorkspaceRole;
  joinedAt: string;
}

export const workspacesApi = {
  list: () => api<Workspace[]>("/v1/workspaces"),
  get: (id: string) => api<Workspace>(`/v1/workspaces/${id}`),
  create: (input: CreateWorkspaceInput) =>
    api<Workspace>("/v1/workspaces", { method: "POST", json: input }),
  update: (id: string, input: UpdateWorkspaceInput) =>
    api<Workspace>(`/v1/workspaces/${id}`, { method: "PATCH", json: input }),
  members: (id: string) => api<Member[]>(`/v1/workspaces/${id}/members`),
  addMember: (
    id: string,
    email: string,
    role: "admin" | "member" = "member",
  ) =>
    api<Member>(`/v1/workspaces/${id}/members`, {
      method: "POST",
      json: { email, role },
    }),
  removeMember: (id: string, userId: string) =>
    api<{ userId: string; removed: true }>(
      `/v1/workspaces/${id}/members/${userId}`,
      { method: "DELETE" },
    ),
};
